import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { TourCard } from '../components/TourCard';
import { tours } from '../utils/mockData';

export const ToursListPage = () => {
  const { t } = useLanguage();

  React.useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleRequestItinerary = () => {
    // Scroll to footer contact or open form
    const footer = document.getElementById('contact');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <SEO 
        title="India Tour Packages & Experiences | Peace of Mind Trips"
        description="Browse curated India tour packages by Peace of Mind Trips, including heritage tours, wellness journeys, wildlife experiences, and immersive cultural travel."
        canonical="/tours"
      />
      <Header onRequestItinerary={handleRequestItinerary} />
      
      {/* Page Header */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-[#F5F3F0] to-[#FAF9F7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-5xl md:text-6xl text-[#2C2C2C] mb-6">
            Our Tours
          </h1>
          <p className="text-lg text-[#8B7D6B] max-w-2xl mx-auto">
            Carefully curated journeys that blend heritage, wellness, and authentic Indian experiences
          </p>
        </div>
      </section>

      {/* Tours Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {tours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};